export default "__VITE_ASSET__82c2c03c__"